import React, {useEffect, useState} from 'react';
import '../styles/style.css';
import {Link, useLocation, useNavigate} from "react-router-dom";
import SiteLogo from '../assets/images/logo.png';
import axios from "axios";
import BASE from "../config";
import Loader from "./Loader";
import Home from "../pages/Home";




const Header = () => {

  const [resorts , SetResorts] = useState([]);
  // const [loader , setLoader] = useState(false);

  const headerResortOrder = [
    "Quinta do Lago",
    "Vale do Lobo",
    "Dunas Douradas",
  ];

  useEffect(() => {
    // setLoader(true);
    axios.get(BASE.BASE_API_URL+"/api/resorts").then((res) =>{
      // console.log("Resorts Data For Header",res);
      SetResorts(res.data.resorts);
    })
  }, []);

  const normalizeResortTitle = (title = "") =>
    title.toLowerCase().replace(/\s+/g, " ").trim();

  const dropdownResorts = headerResortOrder
    .map((title) =>
      resorts.find(
        (resort) => normalizeResortTitle(resort.title) === normalizeResortTitle(title)
      )
    )
    .filter(Boolean);

const location = useLocation();

  return (
    <div>
      <div className="container">
        <nav className="nav">
          <input type="checkbox" id="nav-check" />
          <div className="nav-header">
            <div className="nav-title">
              <Link to="/">
                <img src={SiteLogo} alt="Logo" className="nav-logo" />
              </Link>
            </div>
          </div>
          <div className="nav-btn">
            <label htmlFor="nav-check" className="nav-toggle">
              <span></span>
              <span></span>
              <span></span>
            </label>
          </div>
          <ul className="nav-list">
            <li><Link to="/">Home</Link></li>
            {/*<li><Link to="/property">Property</Link></li>*/}
            <li><Link to="/about">About</Link></li>
            <li>
              <Link to="/resorts">Resorts</Link>
              <ul className="dropdown">
                {dropdownResorts.map((resort) => (
                    <li key={resort.id}>
                      <Link to={`/${resort.title.toLowerCase().replace(/\s+/g, "-")}/${resort.id}`}>
                        {resort.title}
                      </Link>
                    </li>
                ))}
                <li>
                  <Link to="/resorts">View All Resorts</Link>
                </li>
              </ul>

            </li>

            <li><Link to="/faq">Faq</Link></li>
            <li><Link to="/contact">Contact</Link></li>

            {
              location.pathname === '/' ?  <li><a href="#list-with-us">List With Us</a></li> : ""
            }
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Header;